import ExternalLink from '@/ev/ExternalLink';
import { Content } from '@/ev/styles';

export default [
  {
    title: 'Vehicle range',
    content: () => (
      <Content>
        Determine whether the car’s range meets your daily driving needs. The
        average American drives{' '}
        <ExternalLink
          section="Finding a EV"
          url="https://www.carscoops.com/2022/04/qotd-how-far-do-you-typically-drive-each-day/#:~:text=Some%20have%20indicated%20the%20average,is%20unique%20to%20each%20person."
          data-testid="CarScoops Link"
        >
          between 30-40 miles a day
        </ExternalLink>
        , which plenty of reliable commuter EVs can handle easily.
      </Content>
    )
  },
  {
    title: 'Charging infrastructure',
    content: () => (
      <Content>
        Research the availability of charging stations in your area, as well as
        any associated expenses. For example, if you live in a city with a
        well-developed charging network, a used EV with a less extensive range
        may suit your needs just fine. On the other hand, if you live in an area
        with limited charging station availability, you might want to opt for
        something with more range, or even install an EV charger in your home.
      </Content>
    )
  }
];
